import React, { useState } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Card, CardContent } from '../ui/card';

const API = process.env.REACT_APP_BACKEND_URL;

const AdminTimelineTab = ({ timeline, fetchTimeline, authHeaders, showMsg, loading, setLoading }) => {
  const [form, setForm] = useState({ date: '', heading: '', subheading: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/admin/timeline`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(form) });
      if (res.ok) { setForm({ date: '', heading: '', subheading: '' }); fetchTimeline(); showMsg('Timeline event added!'); }
      else showMsg('Failed to add event', 'error');
    } catch { showMsg('Error adding event', 'error'); }
    setLoading(false);
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <Card className="lg:col-span-1 shadow-sm border border-[#E8DFD3] h-fit bg-white">
        <CardContent className="p-5">
          <h3 className="font-bold text-[#2C1810] mb-4 flex items-center gap-2">
            <Plus size={16} className="text-[#5C7A3A]" /> Add Timeline Event
          </h3>
          <form onSubmit={handleSubmit} className="space-y-3">
            <div>
              <label className="text-xs font-medium text-[#7a6555] mb-1 block">Date / Year</label>
              <Input data-testid="timeline-date-input" placeholder="e.g., 2020 or Jan 2023" value={form.date} onChange={e => setForm(f => ({ ...f, date: e.target.value }))} required />
            </div>
            <div>
              <label className="text-xs font-medium text-[#7a6555] mb-1 block">Heading</label>
              <Input data-testid="timeline-heading-input" placeholder="e.g., Founded Nistala's Group" value={form.heading} onChange={e => setForm(f => ({ ...f, heading: e.target.value }))} required />
            </div>
            <div>
              <label className="text-xs font-medium text-[#7a6555] mb-1 block">Subheading</label>
              <Textarea data-testid="timeline-subheading-input" placeholder="Brief description of the milestone" value={form.subheading} onChange={e => setForm(f => ({ ...f, subheading: e.target.value }))} required />
            </div>
            <Button type="submit" data-testid="add-timeline-btn" disabled={loading} className="w-full bg-[#5C7A3A] hover:bg-[#4a6530] text-white cursor-pointer">{loading ? 'Adding...' : 'Add Event'}</Button>
          </form>
        </CardContent>
      </Card>

      <div className="lg:col-span-2 space-y-3">
        {timeline.length === 0
          ? <div className="text-center py-12 text-[#7a6555]" data-testid="no-timeline">No timeline events yet. Add your first milestone.</div>
          : timeline.map(event => (
            <Card key={event.id} className="shadow-sm border border-[#E8DFD3] bg-white" data-testid={`timeline-item-${event.id}`}>
              <CardContent className="p-4 flex items-center gap-4">
                <div className="w-14 h-14 rounded-xl bg-[#5C7A3A]/10 flex items-center justify-center flex-shrink-0">
                  <span className="text-xs font-bold text-[#5C7A3A] text-center leading-tight">{event.date}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-[#2C1810]">{event.heading}</p>
                  <p className="text-sm text-[#7a6555] truncate">{event.subheading}</p>
                </div>
                <Button onClick={async () => {
                  setLoading(true);
                  try {
                    await fetch(`${API}/api/admin/timeline/${event.id}`, { method: 'DELETE', headers: authHeaders() });
                    fetchTimeline(); showMsg('Event deleted');
                  } catch { showMsg('Delete failed', 'error'); }
                  setLoading(false);
                }} variant="ghost" size="sm" data-testid={`delete-timeline-${event.id}`} className="text-red-500 hover:bg-red-50 cursor-pointer"><Trash2 size={16} /></Button>
              </CardContent>
            </Card>
          ))
        }
      </div>
    </div>
  );
};

export default AdminTimelineTab;
